var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03055 9.53055L1.53055 17.0306C1.46087 17.1002 1.37815 17.1555 1.2871 17.1932C1.19606 17.2309 1.09847 17.2503 0.999929 17.2503C0.901383 17.2503 0.803801 17.2309 0.712756 17.1932C0.621712 17.1555 0.538986 17.1002 0.469303 17.0306C0.399621 16.9609 0.344345 16.8781 0.306633 16.7871C0.268921 16.6961 0.249512 16.5985 0.249512 16.4999C0.249512 16.4014 0.268921 16.3038 0.306633 16.2128C0.344345 16.1217 0.399621 16.039 0.469303 15.9693L7.43962 8.99993L0.469303 2.03055C0.328573 1.88982 0.249512 1.69895 0.249512 1.49993C0.249512 1.30091 0.328573 1.11003 0.469303 0.969304C0.610034 0.828573 0.800906 0.749512 0.999929 0.749512C1.19895 0.749512 1.38982 0.828573 1.53055 0.969304L9.03055 8.4693C9.10029 8.53896 9.15561 8.62168 9.19335 8.71272C9.23109 8.80377 9.25052 8.90137 9.25052 8.99993C9.25052 9.09849 9.23109 9.19608 9.19335 9.28713C9.15561 9.37818 9.10029 9.4609 9.03055 9.53055Z",
    fill: "#FAFDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarentRight);
export default __webpack_public_path__ + "static/media/carentRight.08181a5de21f06b280828ad4b7e7726e.svg";
export { ForwardRef as ReactComponent };